import { Link } from 'react-router-dom';
import { useGetAllMatchesByDateStatusQuery } from '../../../../slices/matchApiSlice';
import { DateStatus } from '../../../../utils/constants';
import { ScheduleType } from '../../../schedule/components/schedule-type';

export default function StudentDashboardSchedule({}) {
  const { data, isError, isSuccess, isLoading } = useGetAllMatchesByDateStatusQuery([
    {
      name: '',
      date: '',
      page: 1,
      limit: 3,
    },
    { dateStatus: DateStatus.Live },
  ]);

  if (isLoading) return <p>Loading...</p>;

  return (
    <div className='flex flex-col gap-5'>
      <ScheduleType id={2} />
      {data?.data?.length && data?.meta.total !== data?.data?.length ? (
        <div className='flex justify-center'>
          <Link to='/schedule' className='text-red-700 font-medium hover:text-red-500'>
            View more
          </Link>
        </div>
      ) : null}
    </div>
  );
}
